import { logGenericEvent } from '../wrappers/logGenericEvent';
export function logPerformanceError(error, debugInfo) {
    var _a;
    var params = (_a = {},
        _a["Error" /* Error */] = error,
        _a["DebugInfo" /* DebugInfo */] = debugInfo,
        _a);
    logGenericEvent("Performance_Mark_Failure" /* PerformanceMarkFailure */, params);
}
//# sourceMappingURL=logPerformanceError.js.map